import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { endOfApiScale, startOfApiScale } from '@library/store/measures/measures';
import { EnumApiScales, TimeRange } from '@library/store/measures/measures.interface';
import { Module } from '@library/store/modules/modules.interface';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { ControlPageReportsService, capitalizeFirstLetter } from '@pages/control-page/control-page-main/control-page-reports/control-page-reports.service';
import { EnergyReportsFacade } from '@store/energy-reports/energy-reports.facade';
import { EnergyReport } from '@store/energy-reports/energy-reports.interface';
import * as moment from 'moment-timezone';
import { combineLatest, firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-cp-reports-month-selector',
  templateUrl: './cp-reports-month-selector.component.html',
  styleUrls: ['./cp-reports-month-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
  ]
})
export class CpReportsMonthSelectorComponent {

  report$ = this.energyReportsFacade.currentReport$.pipe(isDefined());

  date = new FormControl();

  viewModel$ = combineLatest({
    report: this.report$,
    timeRange: this.controlPageReportsService.timeRange$.pipe(isDefined()),
    currentDeviceReport: this.controlPageReportsService.reportDevice$.pipe(isDefined()),
  });

  minDate = moment('2015');
  maxDate = null;

  constructor(
    private energyReportsFacade: EnergyReportsFacade,
    private controlPageReportsService: ControlPageReportsService,
  ) { }

  async ngOnInit() {

    const report = await firstValueFrom(this.report$);

    this.maxDate = moment().month(report.month -1).year(report.year);

    this.controlPageReportsService.setTimerange(report.month, report.year);
  }

  async selectDate(date: TimeRange, report: EnergyReport) {
    await this.controlPageReportsService.loadReport(report.device_id, date.dateBegin.month() + 1 , date.dateBegin.year());
    this.controlPageReportsService.timeRange$.next(date);
  }

  getMonth(timeRange: TimeRange) {
    return capitalizeFirstLetter(timeRange?.dateBegin?.format('MMMM YYYY'));
  }

  async selectPreviousTimeRange($event: Event, timeRange: TimeRange, report: EnergyReport) {
    if(report.error && report.error.code === 31) {
      return;
    }
    else {
      $event.stopPropagation();
      const newTimeRange = {
        dateBegin: startOfApiScale(timeRange.dateBegin.clone().subtract(1, 'month'), EnumApiScales.ONE_DAY),
        dateEnd: endOfApiScale(timeRange.dateBegin.clone().subtract(1, 'month'), EnumApiScales.ONE_DAY),
      };
      await this.selectDate(newTimeRange, report);
    }
  }

  async selectNextTimeRange($event: Event,  timeRange: TimeRange, report: EnergyReport, currentDevice: Module) {
    $event.stopPropagation();

    // select next only we have bilan for next month
    if (currentDevice && this.controlPageReportsService.hasNextBilan(report, currentDevice)) {
      const newTimeRange = {
        dateBegin: startOfApiScale(timeRange.dateEnd.clone().add(1, 'day'), EnumApiScales.ONE_DAY),
        dateEnd: endOfApiScale(timeRange.dateEnd.clone().add(1, 'day'), EnumApiScales.ONE_DAY),
      };
      await this.selectDate(newTimeRange, report);
    }
  }

  noNextDate(report: EnergyReport, currentDevice: Module) {
    return !this.controlPageReportsService.hasNextBilan(report, currentDevice);
  }
}
